module.exports = __webpack_public_path__ + "img/pennellata-carosello-prodotti-home.adfabf06.jpg";